import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import useSite from "@casino/legacy/client/hooks/useSite";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import SeeAllLink from "@casino/legacy/client/shared/PageSection/SectionTitle/SeeAllLink";
import capitalize from "@casino/legacy/shared/utils/string/capitalize";
import { cn } from "@workspace/frontend-ui";

type Props = {
  totalCount?: number;
  status?: TournamentStatus;
  isHomeTournaments?: boolean;
  isCurrentTournaments?: boolean;
  onlyMine?: boolean;
};

const SectionTitle: FC<Props> = ({
  status,
  totalCount,
  isHomeTournaments,
  isCurrentTournaments,
  onlyMine,
}) => {
  const title = useTranslation(
    status
      ? `gameleaderboard.${status}`
      : "general.menu_item.my_participations",
  );
  const { asPath } = useRouter();
  const link = onlyMine ? "/profile/tournaments" : `/tournaments/all/${status}`;
  const displayLink = !asPath.includes(link);
  const { isMobile } = useAgentData();
  const { isBitcasino } = useSite();

  if (isHomeTournaments) {
    return (
      <div className="grid grid-flow-col grid-cols-minmax items-center gap-4">
        <h2
          className={cn(
            "text-xl/8 font-medium",
            isBitcasino && "font-headline font-light",
          )}
        >
          <Translate id="game-leaderboard.tournaments" />
        </h2>
        <SeeAllLink $isMobile={isMobile} href="/tournaments">
          <p className="text-sm/6 font-medium">
            <Translate id="casino.see_all" />
          </p>
        </SeeAllLink>
      </div>
    );
  }

  if (isCurrentTournaments) {
    return (
      <div className="grid grid-flow-col grid-cols-minmax items-center gap-4">
        <span className="text-lg/6 text-muted-foreground">
          {capitalize(title.toLowerCase())} ({totalCount})
        </span>
      </div>
    );
  }

  return (
    <div className="grid grid-flow-col grid-cols-minmax items-center gap-4">
      <span className="text-lg/6 text-muted-foreground">
        {capitalize(title.toLowerCase())} ({totalCount})
      </span>
      {displayLink && (
        <SeeAllLink $isMobile={isMobile} href={link}>
          <p className="text-sm/6 font-medium">
            <Translate id="casino.see_all" />
          </p>
        </SeeAllLink>
      )}
    </div>
  );
};

export default SectionTitle;
